<template>
    <div>
        <v-jstree :data="data_files"
                  collapse
                  size="large"
        >
            <template slot-scope="_">

                <div style="display: inherit; width: 200px; height: 30px">
                    <i :class="_.vm.themeIconClasses"
                       role="presentation"
                       :style="colorFolder(_.model)"
                       v-if="!_.model.loading && _.model.type === 'folder'"
                    />
                    <img :src="iconFile(_.model)"
                         height="18px"
                         width="24px"
                         v-else-if="!_.model.loading && _.model.type !== 'folder'"
                         :alt="' '"
                    />

                    <span v-if="_.model.extension"
                          class="mr-3"
                    >
                        {{ _.model.text }}.{{ _.model.extension }}
                    </span>
                    <span v-else
                          class="mr-3"
                    >
                        {{ _.model.text }}
                    </span>

                    <b-btn v-if="_.model.type === 'folder'"
                           variant="primary"
                           class="btn-mini mx-1"
                           @click.stop="openModalName(_.model, true)"
                    >
                        <i class="fa fa-folder"/>
                    </b-btn>

                    <b-btn v-if="_.model.type === 'folder'"
                           variant="secondary"
                           class="btn-mini mx-1"
                           @click.stop="openModalUpload(_.model)"
                    >
                        <i class="fa fa-cloud-upload"/>
                    </b-btn>

                    <b-btn v-if="_.model.type === 'file'"
                           variant="success"
                           class="btn-mini mx-1"
                           @click.stop="_downloadFile(_.model)"
                    >
                        <i class="fa fa-download"/>
                    </b-btn>

                    <b-btn v-if="!_.model.locked"
                           variant="info"
                           class="btn-mini mx-1"
                           @click.stop="openModalName(_.model, false)"
                    >
                        <i class="fa fa-edit"/>
                    </b-btn>

                    <b-btn v-if="!_.model.locked"
                           variant="danger"
                           class="btn-mini mx-1"
                           @click.stop="questionDelete(_.model)"
                    >
                        <i class="fa fa-trash"/>
                    </b-btn>
                </div>
            </template>
        </v-jstree>

        <modal_file @list="_getFiles"/>
        <modal_name @list="_getFiles"/>
    </div>
</template>

<script>

import {mapActions, mapMutations, mapState} from 'vuex';
import VJstree from 'vue-jstree';
import modal_file from './modal_file.vue';
import modal_name from './modal_name.vue';
import Swal from 'sweetalert2';

export default {
    name: 'index',
    components: {
        VJstree,
        modal_file,
        modal_name,
    },
    data() {
        // Variables de datos locales del componente.
        return {
            data_files: [], // Array para almacenar los archivos en formato para VJstree.
            type_files: [ // Tipos de archivos con sus extensiones y iconos asociados.
                {extension: 'pdf', icon: 'pdf', type: 'doc'},
                {extension: 'doc', icon: 'word', type: 'doc'},
                {extension: 'docx', icon: 'word', type: 'doc'},
                {extension: 'xls', icon: 'excel', type: 'doc'},
                {extension: 'csv', icon: 'excel', type: 'doc'},
                {extension: 'xlsx', icon: 'excel', type: 'doc'},
                {extension: 'ppt', icon: 'power-point', type: 'doc'},
                {extension: 'pptx', icon: 'power-point', type: 'doc'},
                {extension: 'png', icon: 'image', type: 'img'},
                {extension: 'jpg', icon: 'image', type: 'img'},
                {extension: 'jpeg', icon: 'image', type: 'img'},
                {extension: 'gif', icon: 'image', type: 'img'}
            ]
        };
    },
    async mounted() {
        // Método que se ejecuta al montar el componente para obtener los archivos del producto.
        await this._getFiles();
    },
    computed: {
        ...mapState('calculator', [
            'files',
            'file',
            'folder',
            'product',
            'product_classifications'
        ])
    },
    methods: {
        ...mapActions('calculator', [
            'getFiles',
            'getFileById',
            'downloadFile',
            'deleteFile'
        ]),
        ...mapMutations('calculator', [
            'setShowToModalFile',
            'setShowToModalName',
            'resetFile',
            'setFile',
            'resetFolder',
            'setFolder',
            'setCreatingToModalName',
            'setShowToModalPreview'
        ]),
        /**
         * Obtener los archivos del producto y prepararlos para el componente VJstree.
         */
        async _getFiles() {
            const product_id = this.$route.params.product_id;
            const company_id = this.$route.params.company_id;

            // Llamada a la acción para obtener los archivos del producto.
            await this.getFiles({product_id, company_id});

            // Estructura inicial de archivos para el componente VJstree.
            let files = [
                {
                    id: null,
                    cal_product_file_id: null,
                    cal_product_id: product_id,
                    type: 'folder',
                    original_name: this.product.name, // Nombre del producto.
                    file_name: null,
                    extension: null,
                    locked: true,
                    files: this.files, // Lista de archivos del producto.
                    opened: true
                }
            ];

            // Transformación de los archivos al formato requerido por VJstree.
            this.data_files = this.getDataFiles(files);
        },
        /**
         * Descargar un archivo específico.
         *
         * @param {Object} file - Representa el archivo que se va a descargar.
         */
        async _downloadFile(file) {
            const company_id = this.$route.params.company_id; // ID de la empresa obtenido de los parámetros de la ruta.

            // Llamada a la acción para obtener el archivo por su ID y luego descargarlo.
            this.getFileById({file, company_id})
                .then(async file_data => {
                    await this.downloadFile(file_data);
                });
        },
        /**
         * Abrir el modal de cambio de nombre de archivo.
         *
         * @param {Object} file - Representa el archivo sobre el cual se abrirá el modal.
         * @param {boolean} creating - Indica si se está creando un nuevo archivo (true) o no (false).
         */
        openModalName(file, creating) {
            if (creating) {
                this.resetFolder();

                let folder = JSON.parse(JSON.stringify(this.folder));

                folder.cal_product_file_id = file.id;
                folder.cal_product_id = file.cal_product_id;
                folder.parent = file;

                this.setFolder(folder);

            } else {
                this.setFolder(file);
            }

            this.setCreatingToModalName(creating);

            this.setShowToModalName(true);
        },
        /**
         * Abrir el modal de carga de archivo.
         *
         * @param {Object} parent - Representa la carpeta padre donde se cargará el archivo.
         */
        openModalUpload(parent) {
            this.resetFile();

            let file = JSON.parse(JSON.stringify(this.file));

            file.cal_product_file_id = parent.id;
            file.cal_product_id = parent.cal_product_id;
            file.parent = parent;

            this.setFile(file);

            this.setShowToModalFile(true);
        },
        /**
         * Transformar la estructura de archivos al formato requerido por VJstree.
         *
         * @param {Array} files - El arreglo de objetos que representa los archivos a transformar.
         * @returns {Array} - El arreglo transformado en el formato requerido por VJstree.
         */
        getDataFiles(files) {
            let data_files = [];

            files.map(f => {
                let item = {
                    id: f.id,
                    text: f.original_name,
                    original_name: f.original_name,
                    extension: f.extension,
                    cal_product_id: f.cal_product_id,
                    locked: f.locked,
                    loading: false,
                    disabled: false,
                    dragDisabled: true,
                    dropDisabled: true,
                    type: f.type,
                    icon: f.type === 'folder' ? 'fa fa-folder' : 'fa fa-file',
                    opened: !!f.opened,
                    selected: false,
                    children: []
                };

                if (f.files.length) {
                    item.children = this.getDataFiles(f.files);
                }

                data_files.push(item);
            });

            return data_files;
        },
        /**
         * Mostrar un mensaje de confirmación antes de eliminar un archivo o carpeta.
         *
         * @param {Object} file - Representa el archivo o carpeta que se va a eliminar.
         */
        async questionDelete(file) {
            let text = '¿Está seguro de eliminar el archivo ' + file.original_name + '.' + file.extension + '?';

            if (file.type === 'folder') {
                text = '¿Está seguro de eliminar la carpeta ' + file.original_name + ' y todo su contenido?';
            }

            await Swal.fire({
                title: 'Eliminar',
                text: text,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Si, eliminar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const company_id = this.$route.params.company_id; // ID de la empresa obtenido de los parámetros de la ruta.
                    this.setFolder(file); // Establecer la carpeta actual para eliminación.
                    await this.deleteFile(company_id);
                    await this._getFiles();
                }
            });
        },
        /**
         * Devuelve la ruta al ícono correspondiente según la extensión del archivo.
         *
         * @param {Object} file - Representa el archivo del cual se desea obtener el ícono.
         * @returns {string} - Ruta al archivo de ícono SVG asociado a la extensión del archivo.
         */
        iconFile(file) {
            let f = this.type_files.find(tf => tf.extension === file.extension);
            return `/calculator/icons/${f.icon}.svg`;
        },
        /**
         * Devuelve el estilo de color CSS dependiendo del tipo de modelo (archivo o carpeta).
         *
         * @param {Object} model - Representa el modelo del cual se desea obtener el color.
         * @returns {string} - Estilo de color CSS aplicable al modelo. Devuelve color naranja (#ffa000) para carpetas y azul (#1667b7) para archivos.
         */
        colorFolder(model) {
            if (model.type === 'folder') {
                return 'color: #ffa000';
            }

            return 'color: #1667b7';
        },
    }
};
</script>

<style>
.btn-mini {
    padding: 0px 4px;
    line-height: 18px;
}
</style>
